import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../../index';
import { RequestOptions, Headers } from '@angular/http';
@Injectable()
export class QuanLyModemDcuService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }

  lay_ds_dcu(danhmucid, meterid, keyword) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_QUANLY_DCU.P_GET_DS_DCU" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_meterid: meterid,
        v_keyword: keyword
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  lay_ds_chuamap(danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_DCU_LENHCAUHINH.P_LAYDS_CHUAMAP" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  danhdau_matdien(imei, matdien, mataikhoan) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_QUANLY_DCU.P_DANHDAU_MATDIEN" }),
      para: JSON.stringify({
        v_imei: imei,
        v_matdien: matdien,
        v_mataikhoan: mataikhoan,
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  thay_dcu(imei_cu, imei_moi, danhmucid, mataikhoan) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_QUANLY_DCU.P_THAY_DCU" }),
      para: JSON.stringify({
        v_imei_cu: imei_cu,
        v_imei_moi: imei_moi,
        v_danhmucid: danhmucid,
        v_mataikhoan: mataikhoan,
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.apiService.Excute("api/QuanLyDCU/UploadExcelReturnJson", formData, options);
  }

  add_cto_chua_map(dslenh: any) {
    return this.apiService.Excute("api/QuanLyDCU/AddChuaMap", dslenh);
  }

  update_maped(ds_id_auto) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_DCU_LENHCAUHINH.P_UPDATE_MAPED" }),
      para: JSON.stringify({
        v_ds_id: ds_id_auto
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  getList_Cto_Map_DCU(danhmucid, imei) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_QUANLY_DCU.P_GET_DS_CTO_MAP_DCU" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }
  getListCto_DCU(imei) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_QUANLY_DCU.P_GET_DS_CTO" }),
      para: JSON.stringify({
        v_imei: imei
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  addDCU(jsondata, imei) {
    let formData: FormData = new FormData();
    formData.append('jsondata', jsondata);
    formData.append('imei', imei);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.apiService.Excute("api/QuanLyDCU/AddCtoDcu", formData, options);
  }
  updateMeterList_mapfromdb(jsondata, imei) {

    let formData: FormData = new FormData();
    formData.append('jsondata', jsondata);
    formData.append('imei', imei);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.apiService.Excute("api/QuanLyDCU/UpdateMeterList_map_from_DB", formData, options);
  }
  updateMeterList(jsondata, imei) {
    let formData: FormData = new FormData();
    formData.append('jsondata', jsondata);
    formData.append('imei', imei);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.apiService.Excute("api/QuanLyDCU/updateMeterList", formData, options);
  }
  deleteMeterList(jsondata, imei) {
    let formData: FormData = new FormData();
    formData.append('jsondata', jsondata);
    formData.append('imei', imei);
    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });
    return this.apiService.Excute("api/QuanLyDCU/DeleteMeterList", formData, options);
  }


  getEXCEL(data: string, title: string, filename: string) {

    let cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
      { "name": "tendanhmuc", "label": "ĐƠN VỊ", "horizontalalignment": "left" },
      { "name": "IP", "label": "IP", "horizontalalignment": "left" },
      { "name": "port", "label": "PORT", "horizontalalignment": "left" },
      { "name": "simcard", "label": "SIMCARD", "horizontalalignment": "left" },
      { "name": "trangthai_text", "label": "Trạng thái", "horizontalalignment": "left" },
      { "name": "matdien_text", "label": "Mất điện", "horizontalalignment": "left" },
    ]


    var param = {
      config: "",
      para: "",
      title: title,
      header: "",
      filename: "Filename",
      sheets: "DANH SÁCH DCU",
      columns: cols,
      data: JSON.stringify(data),
      images: []
    };

    return this.apiService.downloadFile("api/ExportExcel", param, filename);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/quan-ly-modem-dcu/quanlymodemdcu.service.ts